import type { CoreNotifyEvent } from '@/services/websocket/types'

type PendingRun = {
  timer: ReturnType<typeof setTimeout>
  latestEvent: CoreNotifyEvent
  run: (event: CoreNotifyEvent) => void | Promise<void>
}

const pending = new Map<string, PendingRun>()

export function scheduleCoalescedServerEventListenerRun(
  key: string,
  event: CoreNotifyEvent,
  delayMs: number,
  run: (event: CoreNotifyEvent) => void | Promise<void>,
): void {
  const trimmed = String(key ?? '').trim()
  if (!trimmed) {
    void Promise.resolve(run(event)).catch(() => undefined)
    return
  }

  let entry = pending.get(trimmed)
  if (entry) {
    clearTimeout(entry.timer)
    entry.latestEvent = event
    entry.run = run
  } else {
    entry = {
      latestEvent: event,
      run,
      timer: undefined as unknown as ReturnType<typeof setTimeout>,
    }
    pending.set(trimmed, entry)
  }

  entry.timer = setTimeout(() => {
    pending.delete(trimmed)
    const latest = entry!.latestEvent
    const latestRun = entry!.run
    void Promise.resolve(latestRun(latest)).catch(() => undefined)
  }, delayMs)
}

/** @internal */
export function _clearCoalescedServerEventRunsForTest(): void {
  for (const entry of pending.values()) {
    clearTimeout(entry.timer)
  }
  pending.clear()
}

/** @internal */
export function _coalescedServerEventPendingSizeForTest(): number {
  return pending.size
}
